import { MutationTree } from "vuex";
import { GtmData } from "@store/funnel/interfaces/gtmData";
import { FunnelState } from "@store/funnel/interfaces/funnelState";
export default {
    addGtmData(state, gtmData: GtmData) {
        const ecommerceItem = state.ecommerceItem;

        if (gtmData.filter_attributes !== undefined) {
            ecommerceItem.item_id = gtmData.filter_attributes.travel_number ?? 0;
            ecommerceItem.item_brand = gtmData.filter_attributes.tour_operator ?? '';
            ecommerceItem.item_category = gtmData.filter_attributes.travel_type ?? '';
            ecommerceItem.item_category2 = gtmData.filter_attributes.travel_theme ?? '';
            ecommerceItem.item_category3 = gtmData.filter_attributes.travel_feature ?? '';
        }

        if (gtmData.page_attributes !== undefined) {
            ecommerceItem.item_name = gtmData.page_attributes.rt_product ?? '';
            ecommerceItem.item_category4 = gtmData.page_attributes.country ?? '';
        }
        state.ecommerceItem = ecommerceItem;
    },
    addFareToDataLayer(state, fare: string) {
        state.ecommerceItem.item_category5 = fare;
    },
    updateCheckoutFunnel(state, { type, picked }) {
        state.checkoutFunnel[type] = picked;
    }
} as MutationTree<FunnelState>
